module.exports = __webpack_public_path__ + "img/horizontal_7_3_3.243fd813.png";